<template>
  <div>
    <div class="code" v-if="showCode">
      <div class="con">
        <img v-if="imgFlag==0" class="wx-public-img" src="@/assets/image/index/wx-public.jpg">
        <img v-else class="wx-public-img" :src="img">
        <div class="t3">扫码添加</div>
      </div>
      <img @click="closeCode()" style="width: 0.5rem;margin-top: 0.2rem;cursor: pointer" src="../../assets/image/smartCampus/x.png">

    </div>
    <div class="bannerNew">
      <el-carousel style="height: 5.8rem" :autoplay="true" :interval="2000" arrow="never" trigger="click">
        <el-carousel-item style="height: 5.8rem">
          <div class="banner1 b">
            <div class="title">智慧校园</div>
            <div class="desc">覆盖学校各类使用场景，大幅提升教学管理效率</div>
            <div class="q" @click="q()">立即咨询</div>
          </div>
        </el-carousel-item>
        <el-carousel-item style="height: 5.8rem">
          <div class="banner2 b">
            <div class="title">创新模式</div>
            <div class="desc">满足各类场景产品及功能的定制化开发</div>
            <div class="q" @click="q()">立即咨询</div>
          </div>
        </el-carousel-item>
        <el-carousel-item style="height: 5.8rem">
          <div class="banner3 b">
            <div class="title">定制方案</div>
            <div class="desc">项目交付，产品采购，自投自建，运营分成</div>
            <div class="q" @click="q()">立即咨询</div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="wl-solution" id="wl-solution">
      <div class="title">创新校园场景全覆盖，软硬一体定制化解决方案

      </div>
      <div class="nav">
        <div class="nav-con">
          <div :class="['nav-con-title cus-pointer',activeWlSolutionTitle==='市场需求痛点'?'nav-con-title-active':'']"
               @click="updateWlSolutionTitle('市场需求痛点')">市场需求痛点
          </div>
          <div :class="['nav-con-title cus-pointer',activeWlSolutionTitle==='产品及方案'?'nav-con-title-active':'']"
               @click="updateWlSolutionTitle('产品及方案')">产品及方案
          </div>
          <div :class="['nav-con-title cus-pointer',activeWlSolutionTitle==='创新合作模式'?'nav-con-title-active':'']"
               @click="updateWlSolutionTitle('创新合作模式')">创新合作模式
          </div>
        </div>
      </div>
      <div class="con">
        <div class="left">
          <img class="imag" v-if="activeWlSolutionTitle==='市场需求痛点'" src="../../assets/image/smartCampus/cou2.jpg">
          <img class="imag" v-else-if="activeWlSolutionTitle==='产品及方案'"
               src="../../assets/image/smartCampus/cou1.png">
          <img class="imag" v-else-if="activeWlSolutionTitle==='创新合作模式'"
               src="../../assets/image/smartCampus/cou3.png">
          <div class="intro" v-if="activeWlSolutionTitle==='市场需求痛点'">
            <div class="line1">
              <div class="n1">01</div>
              <div class="n2">/03</div>
            </div>
            <div class="line2 ">
              市场需求痛点
            </div>
            <div class="line3">
              <div class="con2 " style="    margin-bottom: -0.15rem;">
                <div class="icon"></div>
                <div class="text">教职工工作量日益增多，需要更智能的工具来提高教学效率；</div>
              </div>
              <div class="con2 " style="    margin-bottom: -0.15rem;">
                <div class="icon"></div>
                <div class="text">学校的应用场景多，众多子系统无法进行有效协调整合，来回切换非常麻烦；</div>
              </div>
              <div class="con2" style="    margin-bottom: -0.15rem;">
                <div class="icon"></div>
                <div class="text">家校互联渠道少，仅依靠老师在私聊/群聊中和家长沟通信息传达单向且不及时；</div>
              </div>
              <div class="con2">
                <div class="icon"></div>
                <div class="text">每所学校都有自己的特色教学方法，常规的标准系统无法应对定制化功能开发；</div>
              </div>
            </div>
          </div>
          <div class="intro" v-else-if="activeWlSolutionTitle==='产品及方案'">
            <div class="line1">
              <div class="n1 ">02</div>
              <div class="n2">/03</div>
            </div>
            <div class="line2">
              全景解决方案
            </div>
            <div class="line4">
              专为中职院校量身打造的一脸通系统，充分结合学校实际需求，支持高度定制化与灵活扩展。不论是管理、教学还是服务，都能轻松应对，确保系统与学校需求完美契合，助力学校实现智能化、高效化管理。
            </div>
          </div>
          <div class="intro" v-else-if="activeWlSolutionTitle==='创新合作模式'">
            <div class="line1">
              <div class="n1">03</div>
              <div class="n2">/03</div>
            </div>
            <div class="line2">
              创新合作模式
            </div>
            <div class="line3">
              <div class="con2">
                <div class="icon"></div>
                <div class="text1">项目交付型：</div>
              </div>
              <div class="desc" style="margin-top: -0.1rem">
                A.标准化软硬件系统平台部署；
              </div>
              <div class="desc">
                B.非标定制化软硬件系统平台部署；
              </div>
            </div>
            <div class="line3">
              <div class="con2">
                <div class="icon"></div>
                <div class="text1" style="margin-top: 0.4rem">投建运营型：</div>
              </div>
              <div class="desc" style="margin-top: -0.1rem">
                由我司投资建设智慧校园软硬件产品，并共享运营收益
              </div>
            </div>
          </div>
        </div>
<!--        <div class="right">-->
<!--          <img src="../../assets/image/rightIcon.png" style="width: 0.1453rem;height: 0.2522rem">-->
<!--        </div>-->
      </div>
    </div>
    <div class="smart-role">
      <div class="title wow animate__animated durationTime animate__fadeInUp">多元化功能配置，满足各种角色的特定需求
      </div>
      <div class="role">
        <div class="name">
          <div :class="[activeRole=='学校'?'point-active-school-text':'']">学校</div>
          <img v-if="activeRole=='学校'" class="a" src="../../assets/image/smartCampus/role/schoolA.png">
          <img v-else class="d" src="../../assets/image/smartCampus/role/schoolD.png" @click="updateRole('学校')">
        </div>
        <div class="line">
          <div :class="['point',activeRole=='学校'?'point-active-school':'']"></div>
          <div class="h"></div>
          <div :class="['point',activeRole=='教师'?'point-active-teacher':'']"></div>
        </div>
        <div class="name">
          <div :class="[activeRole=='教师'?'point-active-teacher-text':'']">教师</div>
          <img v-if="activeRole=='教师'" class="a" src="../../assets/image/smartCampus/role/teacherA.png">
          <img v-else class="d" src="../../assets/image/smartCampus/role/teacherD.png" @click="updateRole('教师')">
        </div>
        <div class="line">
          <div :class="['point',activeRole=='教师'?'point-active-teacher':'']"></div>
          <div class="h"></div>
          <div :class="['point',activeRole=='家长'?'point-active-parent':'']"></div>
        </div>
        <div class="name">
          <div :class="[activeRole=='家长'?'point-active-parent-text':'']">家长</div>
          <img v-if="activeRole=='家长'" class="a" src="../../assets/image/smartCampus/role/parentA.png">
          <img v-else class="d" src="../../assets/image/smartCampus/role/parentD.png" @click="updateRole('家长')">
        </div>
        <div class="line">
          <div :class="['point',activeRole=='家长'?'point-active-parent':'']"></div>
          <div class="h"></div>
          <div :class="['point',activeRole=='学生'?'point-active-student':'']"></div>
        </div>
        <div class="name">
          <div :class="[activeRole=='学生'?'point-active-student-text':'']">学生</div>
          <img v-if="activeRole=='学生'" class="a" src="../../assets/image/smartCampus/role/studentA.png">
          <img v-else class="d" src="../../assets/image/smartCampus/role/studentD.png" @click="updateRole('学生')">
        </div>

      </div>
      <!--这里加key可以保证元素每次重新渲染,动画也就每次能够重新执行-->
      <div  v-if="activeRole=='学校'"
           class="sol s1  wow animate__animated durationTime1 animate__fadeInUp">面向学校各类使用场景，从教务、值班、考勤报修、通知、招生等全方面优化学校管理
      </div>
      <div :key="activeRole" v-else-if="activeRole=='教师'"
           class="sol s2 wow animate__animated durationTime1 animate__fadeInUp">随时随地智能办公，全方位掌握学生动态，减负增效让教学工作更轻松
      </div>
      <div :key="activeRole" v-else-if="activeRole=='家长'"
           class="sol s2 wow animate__animated durationTime1 animate__fadeInUp">
        一手掌握学生在校动态，第一时间了解孩子的安全、消费、学习情况，让家校沟通更密切，共同助力学生健康成长
      </div>
      <div :key="activeRole" v-else-if="activeRole=='学生'"
           class="sol s4 wow animate__animated durationTime1 animate__fadeInUp">线上校园带来便捷性，节约排队时间，让学生有更多的时间精力放在学习和成长当中
      </div>

      <div class="product product-school" v-if="activeRole=='学校'">
        <div ref="imageContainer">
          <div class="line1">
            <div class="item wow animate__animated durationTime1 animate__fadeInUp">
              <img style="cursor: pointer" title="点击放大" @click="openViewer(0)" src="../../assets/image/smartCampus/role/xg.png">
              <div class="t2">学工管理</div>
            </div>
            <div class="item wow animate__animated durationTime1 animate__fadeInUp">
              <img style="cursor: pointer" title="点击放大" @click="openViewer(1)" src="../../assets/image/smartCampus/role/mj.png">
              <div class="t2">门禁管理</div>
            </div>
            <div class="item wow animate__animated durationTime1 animate__fadeInUp">
              <img style="cursor: pointer"  title="点击放大"@click="openViewer(2)" src="../../assets/image/smartCampus/role/xf.png">
              <div class="t2">消费管理</div>
            </div>

          </div>
          <div class="line1" style="margin-top: 0.4rem">
            <div class="item wow animate__animated durationTime1 animate__fadeInUp">
              <img style="cursor: pointer" title="点击放大" @click="openViewer(3)" src="../../assets/image/smartCampus/role/kb.png">
              <div class="t2">课表管理</div>
            </div>
            <div class="item wow animate__animated durationTime1 animate__fadeInUp">
              <img style="cursor: pointer" title="点击放大" @click="openViewer(4)" src="../../assets/image/smartCampus/role/cj.png">
              <div class="t2">成绩管理</div>
            </div>
            <div class="item wow animate__animated durationTime1 animate__fadeInUp">
              <img style="cursor: pointer" title="点击放大" @click="openViewer(5)" src="../../assets/image/smartCampus/role/xyfb.png">
              <div class="t2">校园信息发布</div>
            </div>
          </div>
        </div>
      </div>
      <div class="product product-teacher" v-else-if="activeRole=='教师'">
        <div ref="imageContainer">
          <div class="line1">
            <div class="item wow animate__animated durationTime1 animate__fadeInUp">
              <img style="cursor: pointer" title="点击放大" @click="openViewer(0)" src="../../assets/image/smartCampus/role/tkb.png">
              <div class="t2">老师课表</div>
            </div>
            <div class="item wow animate__animated durationTime1 animate__fadeInUp">
              <img style="cursor: pointer" title="点击放大" @click="openViewer(1)" src="../../assets/image/smartCampus/role/tsw.png">
              <div class="t2">班级事务</div>
            </div>
            <div class="item wow animate__animated durationTime1 animate__fadeInUp">
              <img style="cursor: pointer" title="点击放大" @click="openViewer(2)" src="../../assets/image/smartCampus/role/tqj.png">
              <div class="t2">学生请假</div>
            </div>

          </div>
          <div class="line1 line2" style="margin-top: 0.4rem;margin-left: 1.5rem">
            <div class="item wow animate__animated durationTime1 animate__fadeInUp">
              <img style="cursor: pointer" title="点击放大" @click="openViewer(3)" src="../../assets/image/smartCampus/role/tkq.png">
              <div class="t2">学生考勤</div>
            </div>
            <div class="item wow animate__animated durationTime1 animate__fadeInUp">
              <img style="cursor: pointer" title="点击放大" @click="openViewer(4)" src="../../assets/image/smartCampus/role/tdm.png">
              <div class="t2">课堂点名</div>
            </div>
            <div class="item wow animate__animated durationTime1 animate__fadeInUp">
              <img style="cursor: pointer" title="点击放大" @click="openViewer(5)" src="../../assets/image/smartCampus/role/tlr.png">
              <div class="t2">成绩录入</div>
            </div>
            <div class="item wow animate__animated durationTime1 animate__fadeInUp">
              <img style="cursor: pointer" title="点击放大" @click="openViewer(6)" src="../../assets/image/smartCampus/role/tbz.png">
              <div class="t2">作业布置</div>
            </div>
          </div>
        </div>
      </div>
      <div class="product product-parent" v-else-if="activeRole=='家长'">
        <div ref="imageContainer">
          <div class="line1">
            <div class="item wow animate__animated durationTime1 animate__fadeInUp">
              <img style="cursor: pointer" title="点击放大" @click="openViewer(0)" src="../../assets/image/smartCampus/role/pmj.png">
              <div class="t2">门禁记录</div>
            </div>
            <div class="item wow animate__animated durationTime1 animate__fadeInUp">
              <img style="cursor: pointer" title="点击放大" @click="openViewer(1)" src="../../assets/image/smartCampus/role/pkb.png">
              <div class="t2">学生课表</div>
            </div>
            <div class="item wow animate__animated durationTime1 animate__fadeInUp">
              <img style="cursor: pointer" title="点击放大" @click="openViewer(2)" src="../../assets/image/smartCampus/role/psq.png">
              <div class="t2">学生课表</div>
            </div>

          </div>
          <div class="line1 line2" style="margin-top: 0.4rem;margin-left: 1.5rem">
            <div class="item wow animate__animated durationTime1 animate__fadeInUp">
              <img style="cursor: pointer" title="点击放大" @click="openViewer(3)" src="../../assets/image/smartCampus/role/pcz.png">
              <div class="t2">空中充值</div>
            </div>
            <div class="item wow animate__animated durationTime1 animate__fadeInUp">
              <img style="cursor: pointer" title="点击放大" @click="openViewer(4)" src="../../assets/image/smartCampus/role/pgk.png">
              <div class="t2">消费管控</div>
            </div>
            <div class="item wow animate__animated durationTime1 animate__fadeInUp">
              <img style="cursor: pointer" title="点击放大" @click="openViewer(5)" src="../../assets/image/smartCampus/role/pfx.png">
              <div class="t2">成绩分析</div>
            </div>
            <div class="item wow animate__animated durationTime1 animate__fadeInUp">
              <img style="cursor: pointer" title="点击放大" @click="openViewer(6)" src="../../assets/image/smartCampus/role/ptz.png">
              <div class="t2">学校通知</div>
            </div>
          </div>
        </div>
      </div>
      <div class="product product-student" v-else-if="activeRole=='学生'">
        <div ref="imageContainer">
          <div class="line1">
            <div class="item wow animate__animated durationTime1 animate__fadeInUp">
              <img style="cursor: pointer" title="点击放大" @click="openViewer(0)" src="../../assets/image/smartCampus/role/sdt.png">
              <div class="t2">校园动态</div>
            </div>
            <div class="item wow animate__animated durationTime1 animate__fadeInUp">
              <img style="cursor: pointer" title="点击放大" @click="openViewer(1)" src="../../assets/image/smartCampus/role/scx.png">
              <div class="t2">成绩查询</div>
            </div>
            <div class="item wow animate__animated durationTime1 animate__fadeInUp">
              <img style="cursor: pointer" title="点击放大" @click="openViewer(2)" src="../../assets/image/smartCampus/role/sjf.png">
              <div class="t2">线上缴费</div>
            </div>

          </div>
        </div>
          <div class="line1 line2" style="margin-top: 0.4rem;margin-left: 1.5rem">
            <div class="item wow animate__animated durationTime1 animate__fadeInUp">
              <img class="vImg" @click="openViewer(-1)" src="../../assets/image/smartCampus/role/smj.png">
              <div class="t2">人脸门禁</div>
            </div>
            <div class="item wow animate__animated durationTime1 animate__fadeInUp">
              <img class="vImg" @click="openViewer(-1)" src="../../assets/image/smartCampus/role/szf.png">
              <div class="t2">刷脸支付</div>
            </div>
            <div class="item wow animate__animated durationTime1 animate__fadeInUp">
              <img class="vImg" @click="openViewer(-1)" src="../../assets/image/smartCampus/role/sjb.png">
              <div class="t2">霸凌警报</div>
            </div>
<!--            <div ref="imageContainer">-->
            <div class="item wow animate__animated durationTime1 animate__fadeInUp">
              <img class="vImg" style="cursor: pointer" title="点击放大" @click="openViewer(3)" src="../../assets/image/smartCampus/role/scz.png">
              <div class="t2">在线充值</div>
            </div>
            </div>
<!--          </div>-->

      </div>
    </div>
    <div class="smart-product">
      <div class="title wow animate__animated durationTime animate__fadeInUp">丰富的产品，覆盖校园全场景</div>
      <div class="con">
        <div
          :class="['pBox pm pm1 wow animate__animated durationTime animate__fadeInUp', { active: activeSmartProduct === '进出安全' }]"
          @click="selectSmartProduct('进出安全')">
          <div class="content" v-if="activeSmartProduct=== '进出安全'">
            <div class="intro" v-if="showActiveSmartProductDetail==1">
              <div class="line1">
                <div class="left">进出安全</div>
                <div class="right" @click.stop="changeShowActiveSmartProductDetail(18)">显示产品信息</div>
              </div>
              <img class="line2" src="../../assets/image/smartCampus/p1.jpg">
              <div class="line3 wow animate__animated durationTime1 animate__fadeInUp">
                相关功能：门禁权限、门禁记录、访客管理、进出推送
              </div>
              <div class="line4">

              </div>
              <div class="line5">
                场景介绍：校园各大出入口是校园安全的第一道闸，所以守好这第一道闸的安全至关重要！
                我们通过部署人脸门禁机等智能硬件产品，实现对校园出入口的进出人员身份和门禁权限进行核验。同时全面统计每一次进出记录，保障数据真实可溯源，让家长随时随地掌握孩子动向。
              </div>
            </div>
            <div class="det" v-else>
              <div class="line1">
                <div class="left">进出安全</div>
                <div class="right" @click.stop="changeShowActiveSmartProductDetail()">显示场景信息</div>
              </div>
              <div style="text-align: center">
                <img class="line2" :src="require(`@/assets/${smartProduct.detail.list[0].imgs[0].src}`)"/>
              </div>
              <div class="line3 wow animate__animated durationTime1 animate__fadeInUp">
                {{ smartProduct.name }}
              </div>
              <div class="line4">

              </div>
              <div class="line5">
                <div class="bg">
                  <div style="width: 1.84rem" class="t1 box">摄像头分辨率</div>
                  <div style="width: 1.54rem" class="t1 box">200W</div>
                  <div style="width: 1.64rem" class="t1 box">摄像头类型</div>
                  <div style="flex: 1" class="box">RGB+红外</div>
                </div>
                <div class="bw">
                  <div style="width: 1.84rem" class="t1 box">摄像头光圈</div>
                  <div style="width: 1.54rem" class="t1 box">4.0mm</div>
                  <div style="width: 1.64rem" class="t1 box">摄像头焦距</div>
                  <div style="flex: 1" class="box">0-2M</div>
                </div>
                <div class="bg">
                  <div style="width: 1.84rem" class="t1 box">摄像头白平衡</div>
                  <div style="width: 1.54rem" class="t1 box">自动</div>
                  <div style="width: 1.64rem" class="t1 box">屏幕尺寸</div>
                  <div style="flex: 1" class="box">8英寸，全视角IPS液晶屏</div>
                </div>
              </div>

            </div>
          </div>
          <div v-else class="t">
            进出安全
          </div>
        </div>
        <div
          :class="['pBox pm pm2 wow animate__animated durationTime animate__fadeInRight', { active: activeSmartProduct === '校园消费' }]"
          @click="selectSmartProduct('校园消费')">
          <div class="content" v-if="activeSmartProduct=== '校园消费'">
            <div class="intro" v-if="showActiveSmartProductDetail==1">
              <div class="line1">
                <div class="left">校园消费</div>
                <div class="right" @click.stop="changeShowActiveSmartProductDetail(19)">显示产品信息</div>
              </div>
              <img class="line2" src="../../assets/image/smartCampus/p4.png">
              <div class="line3 wow animate__animated durationTime1 animate__fadeInUp">
                相关功能：刷脸/卡/码支付、消费记录、消费限额、报表统计
              </div>
              <div class="line4">

              </div>
              <div class="line5">
                场景介绍：学生在校期间的消费成为了校方和家长都最为重视但是又容易监管不到位的一点。我们通过向全校消费点部署校园三刷消费机等智能硬件产品，实现让学生拥有更多样的支付方式，让家长更方便准确的查询孩子在校的每一笔消费订单，让校方从多维度掌握学校商户和学生的消费经营情况。
              </div>
            </div>
            <div class="det" v-else>
              <div class="line1">
                <div class="left">校园消费</div>
                <div class="right" @click.stop="changeShowActiveSmartProductDetail()">显示场景信息</div>
              </div>
              <div style="text-align: center">
                <img class="line2" :src="require(`@/assets/${smartProduct.detail.list[0].imgs[0].src}`)"/>
              </div>
              <div class="line3 wow animate__animated durationTime1 animate__fadeInUp">
                {{ smartProduct.name }}
              </div>
              <div class="line4">

              </div>
              <div class="line5">
                <div class="bg">
                  <div style="width: 1.55rem" class="t1 box">产品重量</div>
                  <div style="flex: 1" class="box">约1050克（整机，不包括配件），约1500克（带挂架）</div>
                </div>
                <div class="bw">
                  <div style="width: 1.55rem" class="t1 box">产品尺寸</div>
                  <div style="flex: 1" class="box">长×宽×高 242mm158mm40mm</div>
                </div>
                <div class="bg">
                  <div style="width: 1.55rem" class="t1 box">电源输入</div>
                  <div style="flex: 1" class="box">电压输入 12VDC，最大电流3A 接口为带锁扣的DC 5.52x1插座</div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="t">
            校园消费
          </div>
        </div>
        <div
          :class="['pBox pm pm3 wow animate__animated durationTime animate__fadeInRight', { active: activeSmartProduct === '教务管理' }]"
          @click="selectSmartProduct('教务管理')">
          <div class="content" v-if="activeSmartProduct=== '教务管理'">
            <div class="intro" v-if="showActiveSmartProductDetail==1">
              <div class="line1">
                <div class="left">教务管理</div>
                <div class="right" @click.stop="changeShowActiveSmartProductDetail(22)">显示产品信息</div>
              </div>
              <img class="line2" src="../../assets/image/smartCampus/p3.jpg">
              <div class="line3 wow animate__animated durationTime1 animate__fadeInUp">
                相关功能：学生/教职工档案管理、课表排课、成绩录入、请假管理、宿舍管理
              </div>
              <div class="line4">

              </div>
              <div class="line5">
                场景介绍：当今教师在教学工作的工作量日益增多的情况下，迫切的需要智能化工具来解放双手，留出更多的时间精力用于提高教学效率，提升教学质量。
              </div>
            </div>
            <div class="det" v-else>
              <div class="line1">
                <div class="left">教务管理</div>
                <div class="right" @click.stop="changeShowActiveSmartProductDetail()">显示场景信息</div>
              </div>
              <div style="text-align: center">
                <img class="line2" :src="require(`@/assets/${smartProduct.detail.list[0].imgs[0].src}`)"/>
              </div>
              <div class="line3 wow animate__animated durationTime1 animate__fadeInUp">
                {{ smartProduct.name }}
              </div>
              <div class="line4">

              </div>
              <div class="line5">
                <div class="bg">
                  <div style="width: 1.55rem" class="t1 box">触摸功能</div>
                  <div style="flex: 1" class="box">全新投射式电容屏，G+G 10 点触摸，支持多点手势；</div>
                </div>
                <div class="bw">
                  <div style="width: 1.55rem" class="t1 box">显示</div>
                  <div style="flex: 1" class="box">PC 全高清 HDMI 信号 1080P</div>
                </div>
                <div class="bg">
                  <div style="width: 1.55rem" class="t1 box">PC视频解码</div>
                  <div style="flex: 1" class="box">1080P 全高清（Full HD）MPEG、H.265 等</div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="t">
            教务管理
          </div>

        </div>
        <div
          :class="['pBox pm pm4 wow animate__animated durationTime animate__fadeInRight', { active: activeSmartProduct === '校园霸凌' }]"
          @click="selectSmartProduct('校园霸凌')">
          <div class="content" v-if="activeSmartProduct=== '校园霸凌'">
            <div class="intro" v-if="showActiveSmartProductDetail==1">
              <div class="line1">
                <div class="left">校园霸凌</div>
                <div class="right" @click.stop="changeShowActiveSmartProductDetail(31)">显示产品信息</div>
              </div>
              <img class="line2" src="../../assets/image/smartCampus/p5.png">
              <div class="line3 wow animate__animated durationTime1 animate__fadeInUp">
                相关功能：AI语音识别、敏感词报警、即时对讲、推送事件
              </div>
              <div class="line4">

              </div>
              <div class="line5">
                场景介绍：社会发展迅速，近年来校园霸凌事件愈发严重。我司迅速响应教育部文件指导思想，研发校园放霸凌报警系统。将防霸凌AI设备部署在霸凌高发区域（厕所、楼道、操场、器具室等），设备识别到敏感词（如救命、报警、别打了）将会立即通过多渠道推送报警通知给负责人。即可第一时间通过语音对讲等手段介入，防止霸凌事件发生或恶化。
              </div>
            </div>
            <div class="det" v-else>
              <div class="line1">
                <div class="left">校园霸凌</div>
                <div class="right" @click.stop="changeShowActiveSmartProductDetail()">显示场景信息</div>
              </div>
              <div style="text-align: center">
                <img class="line2" :src="require(`@/assets/${smartProduct.detail.list[0].imgs[0].src}`)"/>
              </div>
              <div class="line3 wow animate__animated durationTime1 animate__fadeInUp">
                {{ smartProduct.name }}
              </div>
              <div class="line4">

              </div>
              <div class="line5">
                <div class="bg">
                  <div style="width: 1.55rem" class="t1 box">麦克风</div>
                  <div style="width: 3.1rem" class="t1 box">双麦，5米拾音，全向</div>
                  <div style="width: 1.39rem" class="t1 box">喇叭</div>
                  <div style="flex: 1" class="box">5W</div>
                </div>
                <div class="bw">
                  <div style="width: 1.55rem" class="t1 box">双向对讲</div>
                  <div style="width: 3.1rem" class="t1 box">支持回音消除</div>
                  <div style="width: 1.39rem" class="t1 box">4G</div>
                  <div style="flex: 1" class="box">全网通</div>
                </div>
                <div class="bg">
                  <div style="width: 1.55rem" class="t1 box">录音</div>
                  <div style="width: 3.1rem" class="t1 box">支持24小时录音，循环储存</div>
                  <div style="width: 1.39rem" class="t1 box">操作系统</div>
                  <div style="flex: 1" class="box">安卓</div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="t">
            校园霸凌
          </div>
        </div>
        <div
          :class="['pBox pm pm5 wow animate__animated durationTime animate__fadeInRight', { active: activeSmartProduct === '家校互联' }]"
          @click="selectSmartProduct('家校互联')">

          <div class="content" v-if="activeSmartProduct=== '家校互联'">
            <div class="intro" v-if="showActiveSmartProductDetail==1">
              <div class="line1">
                <div class="left">家校互联</div>
                <div class="right" @click.stop="changeShowActiveSmartProductDetail(20)">显示产品信息</div>
              </div>
              <img class="line2" src="../../assets/image/smartCampus/p2.png">
              <div class="line3 wow animate__animated durationTime1 animate__fadeInUp">
                相关功能：空中充值、消费管控、成绩分析、校园通知/通话
              </div>
              <div class="line4">

              </div>
              <div class="line5">
                场景描述：现今家长了解孩子在校情况的途径依然还是向老师询问，无非是换成了借助微信/钉钉等线上工具向老师询问。依然会有老师服务不过来，信息传递滞后的情况出现。通过智慧校园家校互联系统，学校发生的一切动态，学生在校的学习，生活情况都将即时更新在家长端上，家长可以随时随地掌握孩子的一切动态。
              </div>
            </div>
            <div class="det" v-else>
              <div class="line1">
                <div class="left">家校互联</div>
                <div class="right" @click.stop="changeShowActiveSmartProductDetail()">显示场景信息</div>
              </div>
              <div style="text-align: center">
                <img class="line2" :src="require(`@/assets/${smartProduct.detail.list[0].imgs[0].src}`)"/>
              </div>
              <div class="line3 wow animate__animated durationTime1 animate__fadeInUp">
                {{ smartProduct.name }}
              </div>
              <div class="line4">

              </div>
              <div class="line5">
                <div class="bg">
                  <div style="width: 1.55rem" class="t1 box">CPU性能</div>
                  <div style="width: 2.47rem" class="t1 box">8核，64位，1.8GHz</div>
                  <div style="width: 1.61rem" class="t1 box">操作系统</div>
                  <div style="flex: 1" class="box">Android9.0</div>
                </div>
                <div class="bw">
                  <div style="width: 1.55rem" class="t1 box">摄像头</div>
                  <div style="width: 2.47rem" class="t1 box">单目，200万像素</div>
                  <div style="width: 1.61rem" class="t1 box">FLASH存储</div>
                  <div style="flex: 1" class="box">eMMC 16GB</div>
                </div>
                <div class="bg">
                  <div style="width: 1.55rem" class="t1 box">显示屏</div>
                  <div style="flex: 1" class="box">10英寸，1280x800像素，多点触控IPS屏</div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="t">
            家校互联
          </div>
        </div>
      </div>
    </div>
    <div class="wl-business" id="wl-business">
      <div class="title wow animate__animated durationTime animate__fadeInUp">智能终端</div>
      <div class="nav1">
        <div class="nav-con">
          <div :class="['nav-con-title cus-pointer',activeWlBusinessTitle==='安全守卫'?'nav-con-title-active':'']"
               @click="updateWlBusinessTitle('安全守卫')">安全守卫
          </div>
          <div :class="['nav-con-title cus-pointer',activeWlBusinessTitle==='消费团餐'?'nav-con-title-active':'']"
               @click="updateWlBusinessTitle('消费团餐')">消费团餐
          </div>
          <div
            :class="['nav-con-title cus-pointer',activeWlBusinessTitle==='智能穿戴'?'nav-con-title-active':'']"
            @click="updateWlBusinessTitle('智能穿戴')">智能穿戴
          </div>
          <div
            :class="['nav-con-title cus-pointer',activeWlBusinessTitle==='校园生活'?'nav-con-title-active':'']"
            @click="updateWlBusinessTitle('校园生活')">校园生活
          </div>
        </div>
      </div>
      <div class="content wow animate__animated durationTime1 animate__fadeInUp" :key="activeWlBusinessTitle">
        <div :class="['productLeft',!showSmartTerminalNext?'vh':'']" @click="getSmartTerminalPreThree"></div>
        <div class="con ">
          <div class="item" v-for="i in smartTerminals">
            <img class="" :src="require(`@/assets/${i.imageSrc}`)">
            <div class="name">{{ i.name }}</div>
          </div>
        </div>
        <div :class="['productRight',!showSmartTerminalNext?'vh':'']" @click="getSmartTerminalNextThree"></div>
      </div>
    </div>
    <div class="smart-made">
      <div class="title wow animate__animated durationTime animate__fadeInUp">满足各类软硬件定制化开发需求</div>
      <div class="box">
        <div class="row1">
          <img src="../../assets/image/smartCampus/made3.jpg">
          <div class="con">
            <div class="t wow animate__animated durationTime animate__fadeInUp">增值功能定制案例</div>
            <div class="u">
              <div class="icon"></div>
              <div class="text wow animate__animated durationTime animate__fadeInUp">硬件定制化：</div>
            </div>

            <div class="desc wow animate__animated durationTime animate__fadeInUp">
              河南某学校需要电子学生证定制化外观并拥有视频功能，我们为其重新开模设计产品外观申请证书，重新定制硬件模块，设计产品方案，最终成功交付。
            </div>
          </div>
        </div>
        <div class="row2">
          <div class="con">
            <div class="t wow animate__animated durationTime animate__fadeInUp">增值功能定制案例</div>
            <div class="u">
              <div class="icon"></div>
              <div class="text wow animate__animated durationTime animate__fadeInUp">软件定制化：</div>
            </div>
            <div class="desc wow animate__animated durationTime animate__fadeInUp">
              江西某学校需要区分付费用户打造差异化，付费用户才能使用人脸通行、人脸支付、空中充值等功能，非付费用户只能使用一卡通，线下排队充值。
            </div>
          </div>
          <img src="../../assets/image/smartCampus/made2.jpg">
        </div>
      </div>

    </div>
    <div class="wl-spec" id="wl-spec">

      <div class="managingPatientSize" id="managingPatientSize">
        <div class="title wow animate__animated durationTime animate__fadeInUp">优秀的产品，造就更多的信任</div>
        <div class="data">
          <div class="item">
            <div class="line1">
              <img src="../../assets/image/wireless/onlineMemnerIcon.png">
              <div class="number">4000</div>
              <div class="text">万+</div>
            </div>
            <div class="line2">
              覆盖用户
            </div>
          </div>
          <!--          <div class="item">-->
          <!--            <div class="line1">-->
          <!--              <img src="../../assets/image/wireless/payUserIcon.png">-->
          <!--              <div class="number">500</div>-->
          <!--              <div class="text">万+</div>-->
          <!--            </div>-->
          <!--            <div class="line2">-->
          <!--              付费用户-->
          <!--            </div>-->
          <!--          </div>-->

          <div class="item">
            <div class="line1">
              <img src="../../assets/image/wireless/partnerIcon.png">
              <div class="number">2000</div>
              <div class="text">+</div>
            </div>
            <div class="line2">
              合作伙伴
            </div>
          </div>
          <div class="item">
            <div class="line1">
              <img src="../../assets/image/wireless/schoolIcon.png">
              <div class="number">300</div>
              <div class="text">+</div>
            </div>
            <div class="line2">
              覆盖学校
            </div>
          </div>
        </div>
        <div class="carousel">
          <div class="carousel-track">
            <div class="productLeft" @click="getSmartCasePreThree"></div>
            <div class="productRight" @click="getSmartCaseNextThree"></div>
            <div
              class="carousel-item"
              v-for="(item, index) in smartCases"
              :key="index"
            >
              <img class="wow animate__animated durationTime animate__fadeInUp"
                   :src="require(`@/assets/${item.imageSrc}`)"/>
              <div class="bot">
                <div class="title animate__animated durationTime animate__fadeInUp" style="text-align: start">
                  {{ item.name }}
                </div>
                <div class="desc animate__animated durationTime animate__fadeInUp">{{ item.desc }}</div>
                <div class="tagsBox">
                  <div class="tags" v-for="desc in item.tags">
                    {{desc}}
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
      <div id="customer-tab" style="padding-top: 0.88rem">
        <div class="customer-title wow animate__animated durationTime animate__fadeInUp">客户案例</div>
        <div style="display: none" class="scroll-container">
          <div class="scroll-content-wrapper">
            <div class="scroll-content">
              <img src="../../assets/image/wireless/haierLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/bydLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/TCLlogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/dcjgLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/fskLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/geliLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/chuangweiLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/meidiLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/cahngchengLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/compalLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/zhongheLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/luxLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/shaunghui.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/jabilLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/goerLogo.png">
            </div>
            <!-- Repeating the same items for seamless scrolling -->
            <div class="scroll-content">
              <img src="../../assets/image/wireless/haierLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/bydLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/TCLlogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/dcjgLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/fskLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/geliLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/chuangweiLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/meidiLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/cahngchengLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/compalLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/zhongheLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/luxLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/shaunghui.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/jabilLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/goerLogo.png">
            </div>
          </div>
        </div>
        <div class="scroll-container" style="margin-top: 0.2rem;margin-bottom: 1rem">
          <div class="scroll-content-wrapper-second">
            <div class="scroll-content">
              <img src="../../assets/image/wireless/ynjiLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/zhejiangligongLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/qdnyLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/gxkjLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/gdlgLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/school1Logo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/gxgyjs.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/school2Logo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/gxjdLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/hnczLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/school3Logo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/school4Logo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/school5Logo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/school6Logo.png">
            </div>
            <!-- Repeating the same items for seamless scrolling -->
            <div class="scroll-content">
              <img src="../../assets/image/wireless/ynjiLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/zhejiangligongLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/qdnyLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/gxkjLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/gdlgLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/school1Logo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/gxgyjs.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/school2Logo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/gxjdLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/hnczLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/school3Logo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/school4Logo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/school5Logo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/school6Logo.png">
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
import productData from "../product/productsData";
import businessData from './business'
import partnerData from '../partner/casesData'
import {backItem} from "../../util/util";
import {WOW} from "wowjs";
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';

export default {
  metaInfo() {
    return {
      title: '智慧校园_智慧校园一体化_智能校园定制管理服务_柠檬网联', // 动态标题
      meta: [
        { name: 'description', content: '柠檬网联是中国数智园区、无线网络解决方案提供商及运营服务商。历经10年发展，已经设计研发了智慧校园、智慧校园一体化、智能校园定制管理服务、无线网络相关一系列的软件、硬件和平台，融合物联网、大数据、云计算、人工智能等新一代信息技术，形成了以网络为基础，以数智校园、数智厂园为应用的“一体两翼”的发展格局，以网络化、数字化、智能化持续助力学校和企业园区的数字化转型升级。'}, // 动态描述
        { name: 'keywords', content: '智慧校园,智慧校园一体化,智能校园定制管理服务' } // 动态关键词
      ]
    };
  },
  name: "smartCampus",
  data() {
    return {
      imgFlag: 0,
      img: '',
      activeWlSpecTitle: '网联优势',
      activeWlSolutionTitle: '市场需求痛点',
      softProduct: [],
      showCode:false,
      hardwareProduct: [
        {
          id: 1,
          name: '网关',
          imageSrc: 'image/wireless/productGw.png',
        },
        {
          id: 2,
          name: '交换机',
          imageSrc: 'image/wireless/productSw.png',
        },
        {
          id: 3,
          name: 'AP',
          imageSrc: 'image/wireless/productAp.png',
        },
        {
          id: 30,
          name: '防代理',
          imageSrc: 'image/wireless/productDl.png',
        },
      ],
      activeSoftProduct: [],
      activeHardwareProduct: [],
      currentSoftIndex: 0,
      currentHardwareIndex: 0,
      listPictures: ['https://lemonwifi.cn/officialStatic/img/wirelessBanner.4a35cff.jpg', 'https://lemonwifi.cn/officialStatic/img/detail-night-bg.320d13d.png'],
      listPictures1: ['https://lemonwifi.cn/officialStatic/img/about.d1f2e1b.png', 'https://lemonwifi.cn/officialStatic/img/banbg.04de048.png'],
      vMaxSchool: [
        'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/guaanwang/%E5%AD%A6%E5%B7%A5%E7%AE%A1%E7%90%86.jpg',
        'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/guaanwang/%E9%97%A8%E7%A6%81%E7%AE%A1%E7%90%86.jpg',
        'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/guaanwang/%E6%B6%88%E8%B4%B9%E7%AE%A1%E7%90%86.jpg',
        'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/guaanwang/%E6%8E%92%E8%AF%BE%E7%AE%A1%E7%90%86.jpg',
        'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/guaanwang/%E6%88%90%E7%BB%A9%E7%AE%A1%E7%90%86.jpg',
        'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/guaanwang/%E6%A0%A1%E5%9B%AD%E4%BF%A1%E6%81%AF%E5%8F%91%E5%B8%83.jpg',
      ],
      vMaxTeacher: [
        'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/guaanwang/%E6%95%99%E5%B8%88%E8%AF%BE%E8%A1%A8.jpg',
        'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/guaanwang/%E7%8F%AD%E7%BA%A7%E4%BA%8B%E5%8A%A1.jpg',
        'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/guaanwang/%E5%AD%A6%E7%94%9F%E8%AF%B7%E5%81%87.jpg',
        'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/guaanwang/%E7%8F%AD%E7%BA%A7%E5%AD%A6%E7%94%9F%E8%80%83%E5%8B%A4.jpg',
        'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/guaanwang/%E4%B8%8A%E8%AF%BE%E7%82%B9%E5%90%8D.png',
        'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/guaanwang/%E6%88%90%E7%BB%A9%E5%BD%95%E5%85%A5.jpg',
        'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/guaanwang/%E4%BD%9C%E4%B8%9A%E5%B8%83%E7%BD%AE.png'
      ],
      vMaxParent: [
        'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/guaanwang/%E9%97%A8%E7%A6%81%E8%AE%B0%E5%BD%95.png',
        'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/guaanwang/%E5%AD%A6%E7%94%9F%E8%AF%BE%E8%A1%A8.png',
        'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/guaanwang/%E5%88%B0%E8%AE%BF%E7%94%B3%E8%AF%B7.png',
        'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/guaanwang/%E7%A9%BA%E4%B8%AD%E5%85%85%E5%80%BC.png',
        'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/guaanwang/%E6%B6%88%E8%B4%B9%E7%AE%A1%E7%90%86.jpg',
        'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/guaanwang/%E6%88%90%E7%BB%A9%E5%88%86%E6%9E%90.jpg',
        'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/guaanwang/%E5%AD%A6%E6%A0%A1%E9%80%9A%E7%9F%A5.png',

      ],
      vMaxStudent: [
        'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/guaanwang/%E6%A0%A1%E5%9B%AD%E5%8A%A8%E6%80%81.png',
        'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/guaanwang/%E6%88%90%E7%BB%A9%E6%9F%A5%E8%AF%A2.png',
        'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/guaanwang/%E7%BA%BF%E4%B8%8A%E7%BC%B4%E8%B4%B9.png',
        'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/guaanwang/%E5%9C%A8%E7%BA%BF%E5%85%85%E5%80%BC.png'
      ],
      vPicture: [
        {
          thumbnail: 'https://lemonwifi.cn/officialStatic/img/wirelessBanner.4a35cff.jpg',
          original: 'https://lemonwifi.cn/officialStatic/img/about.d1f2e1b.png',
        },
        {
          thumbnail: 'https://lemonwifi.cn/officialStatic/img/detail-night-bg.320d13d.png',
          original: 'https://lemonwifi.cn/officialStatic/img/banbg.04de048.png',
        },
        // 更多图片
      ],
      wlSolution: [
        {
          title: "市场需求痛点",
          img: 'image/wireless/solution1.png',
          activeImg: 'image/wireless/solutionActive1.png',
          showVideo: 'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/video/3d14e7c593a24ca1808999dc03ce3630/solu/001.mp4',
        },
        {
          title: "创新解决方案",
          img: 'image/wireless/solution2.png',
          activeImg: 'image/wireless/solutionActive2.png',
          showVideo: 'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/video/3d14e7c593a24ca1808999dc03ce3630/solu/002.mp4',
        },
        {
          title: "创新运营模式",
          img: 'image/wireless/solution3.png',
          activeImg: 'image/wireless/solutionActive4.png',
          showVideo: 'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/video/3d14e7c593a24ca1808999dc03ce3630/solu/003.mp4',
        },
        {
          title: "创新合作模式",
          img: 'image/wireless/solution4.png',
          activeImg: 'image/wireless/solutionActive3.png',
          showVideo: 'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/video/3d14e7c593a24ca1808999dc03ce3630/solu/004.mp4',
        },
      ],
      wlSolutionActive: [],
      wlSolutionCurrentIndex: 3,
      activeWlBusinessTitle: '安全守卫',
      businessInfo: null,
      video: '',
      showVideoState: false,
      isSticky: false,
      activeSmartProduct: "进出安全",
      showActiveSmartProductDetail: 1,
      smartCaseId: [44, 45, 46, 47,48,49,50,51],
      smartCases: [],
      currentsSmartCaseIndex: 0,
      showSmartTerminalNext: false,
      smartTerminal: {
        "安全守卫": [18, 23, 32],
        "消费团餐": [29, 38, 33],
        "智能穿戴": [21, 34, 39],
        "校园生活": [35, 22, 36, 37],
      },
      smartTerminals: [],
      activeSmartTerminal: 0,
      smartProduct: null,
      activeRole: "学校",
      viewerInstance: null,
    }
  },
  mounted() {
    // 确保 DOM 渲染完成后再初始化 Viewer.js 实例
    this.$nextTick(() => {
      if (this.$refs.imageContainer) {
        try {
          console.log('Initializing Viewer.js instance...');
          // 初始化 Viewer.js 实例，使用压缩图片进行展示
          this.viewerInstance = new Viewer(this.$refs.imageContainer, {
            toolbar: false,
            navbar: false,
            zoomable: true,
            inline: false,
            movable: false,
            rotatable: false
          });
          console.log('Viewer.js instance:', this.viewerInstance);
        } catch (error) {
          console.error('Failed to initialize Viewer.js:', error);
        }
      } else {
        console.error('Image container not found.');
      }
    });
    const wow = new WOW({
      boxClass: "wow", //需要执行动画元素的Class
      animateClass: "animated_lightSpeedIn", //animation.css动画的Class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备执行动画
      live: true,//异步加载的内容是否有效
    });
    wow.init();

  },
  created() {

    this.initializeAndRun();
    this.softProduct = productData.filter(
      v => v.jump === "soft" && ['运维管理', '高阶辅助'].includes(v.type) && v.id !== 8
    );
    this.updateWlBusinessTitle(this.activeWlBusinessTitle)
    this.getSmartCaseNextThree();
    this.getSmartTerminalNextThree();

  },
  beforeDestroy() {
    // 组件销毁时清理 Viewer.js 实例
    if (this.viewerInstance) {
      this.viewerInstance.destroy();
    }
  },
  methods: {
    openViewer(index) {
      if (index == -1) {
        return;
      }
      let l = [];
      if (this.activeRole == '学校') {
        l = this.vMaxSchool;
      } else if (this.activeRole == '教师') {
        l = this.vMaxTeacher;
      } else if (this.activeRole == '家长') {
        l = this.vMaxParent;
      } else if (this.activeRole == '学生') {
        l = this.vMaxStudent;
      }
      if (this.viewerInstance) {
        // 销毁现有 Viewer 实例
        this.viewerInstance.destroy();

        // 重新创建新的 Viewer 实例，加载高清图片
        this.viewerInstance = new Viewer(this.$refs.imageContainer, {
          url: (image) => l[index],  // 根据点击索引加载高清图片
          toolbar: false,
          navbar: false,
          zoomable: true,
          inline: false,
          movable: false,
          rotatable: false,
          shown: () => {
            // 给图片设置圆角
            const viewerImage = document.querySelector('.vImg');
            if (viewerImage) {
              viewerImage.style.borderRadius = '10px';  // 设置圆角
            }
          }
        });

        // 打开指定索引的高清图片进行预览
        this.viewerInstance.view(index);
        this.viewerInstance.show(); // 显示预览
      } else {
        console.error('Viewer.js instance is not initialized.');
      }
    },
    updateRole(name) {
      this.activeRole = name;
    },
    getSmartTerminalNextThree() {
      let result = [];
      this.smartTerminals = [];
      let list = [];
      for (let key in this.smartTerminal) {
        if (key === this.activeWlBusinessTitle) {
          // 找到匹配的终端名称
          list.push(...this.smartTerminal[key]);
          break;
        }
      }
      if (list.length < 3) {
        result = list;
      } else {
        this.showSmartTerminalNext = list.length > 3;
        for (let i = 0; i < 3; i++) {
          result.push(list[(this.activeSmartTerminal + i) % list.length]);
        }
        this.activeSmartTerminal = (this.activeSmartTerminal + 1) % list.length;
      }
      result.forEach(i => {
        this.smartTerminals.push(productData.filter(item => item.id === i)[0])
      })
      console.log(this.smartTerminals)
    },
    getSmartTerminalPreThree() {
      const result = [];
      this.smartTerminals = [];
      let list = [];
      for (let key in this.smartTerminal) {
        if (key === this.activeWlBusinessTitle) {
          // 找到匹配的终端名称
          list.push(...this.smartTerminal[key]);
          break;
        }
      }
      for (let i = 0; i < 3; i++) {
        result.push(list[(this.activeSmartTerminal - i + list.length) % list.length]);
      }
      this.activeSmartTerminal = (this.activeSmartTerminal - 1 + list.length) % list.length;
      result.reverse().forEach(i => {
        this.smartTerminals.push(productData.filter(item => item.id === i)[0])
      })
      console.log(this.smartTerminals)
    },
    getSmartCaseNextThree() {
      const result = [];
      this.smartCases = [];
      for (let i = 0; i < 3; i++) {
        result.push(this.smartCaseId[(this.currentsSmartCaseIndex + i) % this.smartCaseId.length]);
      }
      this.currentsSmartCaseIndex = (this.currentsSmartCaseIndex + 1) % this.smartCaseId.length;
      result.forEach(i => {
        this.smartCases.push(partnerData.filter(item => item.id === i)[0])
      })
      console.log(this.smartCases)
    },
    getSmartCasePreThree() {
      const result = [];
      this.smartCases = [];
      for (let i = 0; i < 3; i++) {
        result.push(this.smartCaseId[(this.currentsSmartCaseIndex - i + this.smartCaseId.length) % this.smartCaseId.length]);
      }
      this.currentsSmartCaseIndex = (this.currentsSmartCaseIndex - 1 + this.smartCaseId.length) % this.smartCaseId.length;
      result.reverse().forEach(i => {
        this.smartCases.push(partnerData.filter(item => item.id === i)[0])
      })
      console.log(this.smartCases)
    },
    changeShowActiveSmartProductDetail(id) {
      if (this.showActiveSmartProductDetail == 1) {
        this.showActiveSmartProductDetail = 2
      } else {
        this.showActiveSmartProductDetail = 1
      }
      if (id == null || id == undefined) {
        return;
      }
      this.smartProduct = productData.filter(item => item.id == id)[0];
      console.log(this.smartProduct);


    },
    selectSmartProduct(name) {
      if (name == this.activeSmartProduct) {
        return;
      }
      this.showActiveSmartProductDetail = 1;
      this.activeSmartProduct = name;
    },

    handleCloseVideo() {
      this.showVideoState = false;
    },
    showVideo(url) {
      this.video = url;
      this.showVideoState = true;
    },
    businessJump(id) {
      this.$router.push({
        name: "partnerDetail",
        query: {
          id: id
        }
      });
    },
    productJump(id, type) {
      this.$router.push({
        name: type == 'soft' ? 'productDetailSoft' : 'productDetail',
        query: {
          id: id
        }
      });
    },
    updateWlBusinessTitle(title) {
      this.activeWlBusinessTitle = title;
      this.activeSmartTerminal = 0;
      this.getSmartTerminalNextThree()
    },
    updateWlSolutionTitle(title) {
      this.activeWlSolutionTitle = title;
    },
    loadScript(src, id) {
      return new Promise((resolve, reject) => {
        if (document.getElementById(id)) {
          resolve(); // 如果脚本已经存在，直接resolve
          return;
        }

        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        script.id = id;

        script.onload = () => {
          resolve(); // 脚本加载成功，resolve
        };

        script.onerror = () => {
          reject(new Error(`Script load error for ${src}`)); // 脚本加载失败，reject
        };

        let s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(script, s);
      });
    },
    async initializeAndRun() {
      try {
        await this.loadScript(
          'https://material.weiling.cn/h5/willing-third-party-js/v1/qrcode-custom-comp-v1.min.js',
          'wlQRCS'
        );

        // 等待脚本加载完成后初始化
        wlQrcodeCustomComp.init({
          wl_id: 'wpW2WmDAAAsuSkpyHYrwjV4tnMu-Zjag', // [修改1：将wl_id粘贴至此]
        });

        // 初始化完成后要执行的代码
        console.log('wlQrcodeCustomComp initialized');
        // 在这里添加你需要执行的代码
        this.getCode();
      } catch (error) {
        console.error(error); // 处理加载脚本时的错误
      }
    },
    getCode() {
      wlQrcodeCustomComp.getQrCodeUrl(
        {
          wl_qrcode_id: "1801157726622015488", //  [修改1：将wl_qrcode_id粘贴至此]
        },
        (data) => {
          console.log(data); // data中包含二维码图片地址
          if (data.code == 200) {
            this.imgFlag = 1;
            this.img = data.data.qr_code;
          }
        }
      );
    },
    closeCode(){
      this.showCode=false
    },
    updateWlSpecTitle(title, id) {
      this.activeWlSpecTitle = title;
      backItem(id);
    },
    q(){
      this.showCode=true;
    }
  }
}
</script>

<style scoped lang="scss">
.bannerNew{
  .title{
    font-weight: 500;
    font-size: 0.44rem;
    color: #FFFFFF;

  }
  .desc{
    font-weight: 400;
    font-size: 0.24rem;
    color: #FFFFFF;
    margin-top: 0.2rem;
    margin-bottom: 0.39rem;
  }
  .q{
    width: 3.7rem;
    height: 0.6rem;
    background: #FEF100;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    font-size: 0.2rem;
    color: #333333;
    cursor: pointer;
  }
  .banner1{
    background: url('../../assets/image/smartCampus/schoolBg1.jpg') center no-repeat;
    background-size: cover;
  }
  .b{

    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 5.8rem;
    flex-direction: column;
  }
  .banner2{
    background: url('../../assets/image/smartCampus/schoolBg2.jpg') center no-repeat;
    background-size: cover;
  }
  .banner3{
    background: url('../../assets/image/smartCampus/schoolBg3.jpg') center no-repeat;
    background-size: cover;
  }
}

.smart-made {
  background: #F2F7FE;
  padding: 1rem 1.8rem;

  .title {
    font-weight: 500;
    font-size: 0.32rem;
    color: #333333;
    margin-bottom: 0.8rem;
    text-align: center;
  }

  .box {
    display: flex;

    .u {
      display: flex;
      position: relative; /* 相对定位 */
      padding-left: 0.2rem; /* 圆点的宽度加上间距 */
      margin-bottom: 0.2rem;
      line-height: 0.3rem;
      margin-top: 0.2rem;

      .icon {
        position: absolute; /* 绝对定位 */
        left: 0; /* 相对于 .list-item 左侧对齐 */
        //transform: translateY(-50%); /* 垂直居中 */
        width: 0.1rem; /* 圆点的直径 */
        height: 0.1rem;
        background-color: #FEF100; /* 圆点的颜色 */
        border-radius: 50%; /* 将正方形变成圆形 */
        margin-right: 0.1rem; /* 圆点和文字之间的间距 */
        margin-top: 0.1rem;

      }

      .text {
        font-weight: 400;
        font-size: 0.2rem;
        color: #333333;
      }

      .text1 {
        font-size: 0.23rem;
        color: #3B5377;
        line-height: 0.38rem;
      }
    }

    .row1 {
      display: flex;
      align-items: flex-start;
      flex-direction: column;

      .con {
        padding: 1.14rem 0.6rem 1.21rem 0;

        .t {
          font-weight: 500;
          font-size: 0.28rem;
          color: #333333;
        }

        .desc {
          width: 7.2rem;
          font-weight: 400;
          font-size: 0.16rem;
          color: #333333;
          line-height: 0.3rem;
        }
      }

    }

    .row2 {
      display: flex;
      align-items: flex-start;
      flex-direction: column;

      .con {
        padding: 1.04rem 0 1.11rem 0.6rem;

        .t {
          font-weight: 500;
          font-size: 0.28rem;
          color: #333333;
        }

        .desc {
          width: 7.2rem;
          font-weight: 400;
          font-size: 0.16rem;
          color: #333333;
          line-height: 0.3rem;
        }
      }
    }

  }

}

.wl-solution {
  padding-top: 1rem;
  padding-bottom: 1rem;
  background: #F7F7F7;

  .title {
    font-weight: 500;
    font-size: 0.32rem;
    color: #333333;
    text-align: center;
    margin-bottom: 0.8rem;
  }

  .nav {
    display: flex;
    justify-content: center;

    .nav-con {
      width: 15.6rem;
      padding-top: 0.22rem;
      padding-left: 3rem;
      padding-right: 3rem;
      //background: #FFFFFF;
      //box-shadow: 0px 0.03rem 0.06rem 0.01px rgba(0,0,0,0.16);
      border-bottom: 0.01rem solid #DBDBDB;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .nav-con-title {
        //margin-left: 0.8rem;
        font-weight: 400;
        font-size: 0.2rem;
        color: #333333;
        padding-bottom: 0.22rem;
      }

      .nav-con-title-active {
        font-weight: 500;
        padding-bottom: 0.21rem;
        color: #3B5377;
        border-bottom: 0.01rem solid #3B5377;
      }
    }
  }

  .con {
    margin-top: 0.4rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1.7rem;

    .left {
      display: flex;
      //transition: transform 0.5s ease;
      .imag {
        width: 8.6rem;
        height: 5.41rem;
        z-index: 9;
        border-radius: 0.2rem;
      }

      .intro {
        height: 6.1rem;
        background: #FFFFFF;
        border-radius: 0.1rem;
        width: 9.65rem;
        margin-left: -0.95rem;
        padding-left: 1.7rem;
        padding-top: 0.4rem;
        padding-right: 0.82rem;

        .line1 {
          display: flex;
          align-items: flex-end;

          .n1 {
            font-weight: 500;
            font-size: 0.54rem;
            color: #FEF100;
            line-height: 0.5rem;
            margin-right: 0.1rem;
          }

          .n2 {
            font-weight: 500;
            font-size: 0.28rem;
            color: #999999;
          }
        }

        .line2 {
          font-weight: 500;
          font-size: 0.32rem;
          color: #333333;
          margin: 0.5rem 0 0.4rem 0;
        }

        .line3 {
          .desc {
            font-weight: 400;
            font-size: 0.2rem;
            line-height: 0.35rem;
            color: #333333;
            margin-left: 0.3rem;
          }

          .con2 {
            display: flex;
            position: relative; /* 相对定位 */
            padding-left: 0.2rem; /* 圆点的宽度加上间距 */
            margin-bottom: 0.2rem !important;
            line-height: 0.3rem;
            align-items: start;


            .icon {
              position: absolute; /* 绝对定位 */
              left: 0; /* 相对于 .list-item 左侧对齐 */
              //transform: translateY(-50%); /* 垂直居中 */
              width: 0.1rem; /* 圆点的直径 */
              height: 0.1rem;
              background-color: #FEF100; /* 圆点的颜色 */
              border-radius: 50%; /* 将正方形变成圆形 */
              margin-right: 0.1rem; /* 圆点和文字之间的间距 */
              margin-top: 0.1rem;

            }

            .text {
              font-weight: 400;
              font-size: 0.2rem;
              color: #333333;
            }

            .text1 {
              font-size: 0.23rem;
              color: #3B5377;
              line-height: 0.38rem;
            }
          }
        }

        .line4 {
          font-weight: 400;
          font-size: 0.2rem;
          color: #333333;
          line-height: 0.3rem;
        }
      }
    }
  }


}

.smart-role {
  background: url('../../assets/image/smartCampus/roleBg.jpg') center no-repeat;
  background-size: cover;
  padding: 1rem 1.8rem;

  .title {
    font-weight: 500;
    font-size: 0.32rem;
    color: #333333;
    text-align: center;
  }

  .sol {
    font-weight: 500;
    font-size: 0.24rem;
    color: #333333;
    text-align: center;
    margin-top: 2rem;
  }

  .role {
    display: flex;
    margin-top: 0.8rem;
    padding: 0 2rem;

    .name:hover .d {
      transform: scale(1.1);
    }

    .name {
      font-weight: 500;
      font-size: 0.2rem;
      color: #333333;
      position: relative;

      .d {
        margin-top: 0.2rem;
        position: absolute;
        width: 0.9568rem;
        left: -0.2rem;
        transition: transform 0.3s ease-in-out;
        height: initial;
        max-width: initial;
        cursor: pointer;
      }

      .a {
        margin-top: 0.2rem;
        position: absolute;
        width: 1.53rem;
        left: -0.55rem;
        height: initial;
        max-width: initial;
      }
    }

    .line {
      display: flex;
      align-items: center;
      margin: 0 0.3rem;

      .point {
        width: 0.11rem;
        height: 0.11rem;
        background: #DBDBDB;
        border-radius: 50%;
      }

      .h {
        width: 2.4rem;
        height: 0.04rem;
        background: #DBDBDB;
      }
    }
  }

  .product {
    margin-top: 0.4rem;
    background-size: cover;
    padding: 0.77rem 0;
  }

  .line1 {
    display: flex;
    justify-content: center;

    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 1.5rem;

      img {
        width: 1.86rem !important;
        height: 1rem;
        margin-bottom: 0.2rem;
      }

      .t2 {
        font-weight: 400;
        font-size: 0.2rem;
        color: #333333;
      }

    }

    .item:last-child {
      margin-right: 0;
    }

  }

  .line2 {
    .item {
      margin-right: 0.99rem !important;
    }

    .item:last-child {
      margin-right: 0;
    }

  }

  .product-school {
    background: url('../../assets/image/smartCampus/role/schoolBg.jpg') center no-repeat;
    background-size: cover;
    padding: 0.77rem 0;


  }

  .product-teacher {
    background: url('../../assets/image/smartCampus/role/teacherBg.png') center no-repeat;
    background-size: cover;


  }

  .product-parent {
    background: url('../../assets/image/smartCampus/role/parentBg.jpg') center no-repeat;
    background-size: cover;
  }

  .product-student {
    background: url('../../assets/image/smartCampus/role/studentBg.jpg') center no-repeat;
    background-size: cover;
  }
}

.smart-product {
  padding: 1rem 1.8rem;
  background: url('../../assets/image/smartCampus/smartBg.jpg') center no-repeat;
  background-size: cover;

  .title {
    font-weight: 500;
    font-size: 0.32rem;
    color: #333333;
    text-align: center;
    margin-bottom: 0.8rem;
  }

  .con {
    display: flex;
    justify-content: space-between;

    .pm {
      opacity: 0.7 !important;
    }

    .pm1 {
      background: url('../../assets/image/smartCampus/pf1.png') center no-repeat;

    }

    .pm2 {
      background: url('../../assets/image/smartCampus/pf2.png') center no-repeat;
    }

    .pm3 {
      background: url('../../assets/image/smartCampus/pf3.png') center no-repeat;
    }

    .pm4 {
      background: url('../../assets/image/smartCampus/pf4.png') center no-repeat;
    }

    .pm5 {
      background: url('../../assets/image/smartCampus/pf5.png') center no-repeat;
    }

    .pBox {
      flex: 1;
      margin: 0 0.1rem;
      //transition: flex 0.5s ease;

      background-size: cover;
      height: 7.55rem;
      cursor: pointer;


      .t {
        font-weight: 500;
        font-size: 0.28rem;
        text-align: center;
        color: #FFFFFF;
        margin-top: 2.48rem;
      }

      .content {
        padding: 0.4rem;
        cursor: auto;

        .line1 {
          display: flex;
          justify-content: space-between;
          margin-bottom: 0.2rem;

          .left {
            font-weight: 500;
            font-size: 0.28rem;
            color: #3B5377;
          }

          .right {
            background: url('../../assets/image/btBg.png') center no-repeat;
            background-size: contain;
            width: 1.4145rem;
            height: 0.4244rem;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: 400;
            font-size: 0.16rem;
            color: #333333;
            cursor: pointer;
          }
        }

        .line3 {
          margin-top: 0.35rem;
          font-weight: 500;
          font-size: 0.24rem;
          color: #3B5377;
        }

        .line4 {
          height: 0.2rem;
          width: 2.6rem;
          border-bottom: 0.01rem solid #999999;
          margin-bottom: 0.2rem;
        }

        .intro {


          .line5 {
            font-weight: 400;
            font-size: 0.16rem;
            color: #333333;
            line-height: 0.3rem;
          }
        }

        .det {
          .line2 {
            height: 3.9rem;
          }

          .line5 {
            margin-left: -0.4rem;
            margin-right: -0.4rem;
            font-weight: 400;
            font-size: 0.18rem;
            color: #333333;

            .box {
              padding-left: 0.4rem;
              display: flex;
              align-items: center;
              height: 0.51rem;
            }

            .t1 {
              border-right: 0.01rem solid #FFFFFF;
            }

            .bw {
              background: #F7F7F7;
              display: flex;
            }

            .bg {
              background: #E6E6E6;
              display: flex;
            }
          }
        }
      }
    }

    .pBox.active {
      flex: 4.3;
      background: white;
      border-radius: 0.08rem;
      opacity: 1 !important;
    }

    .pBox:hover {
      opacity: 1 !important;
    }

    /* 没有 .active 的色块恢复为 1 倍宽度 */
    .pBox:not(.active) {
      flex: 1;
    }
  }
}

.wl-business {
  padding-top: 1rem;
  padding-bottom: 1rem;

  .title {
    font-weight: 500;
    font-size: 0.32rem;
    color: #333333;
    text-align: center;
    margin-bottom: 0.7rem;
  }

  .nav1 {
    display: flex;
    justify-content: center;

    .nav-con {
      width: 15.6rem;
      padding-top: 0.22rem;
      padding-left: 3.8rem;
      padding-right: 3.8rem;
      background: #FFFFFF;
      //box-shadow: 0px 0.03rem 0.06rem 0.01px rgba(0,0,0,0.16);
      border-bottom: 0.01rem solid #DBDBDB;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .nav-con-title {
        //margin-left: 0.8rem;
        font-weight: 400;
        font-size: 0.2rem;
        color: #333333;
        padding-bottom: 0.22rem;
      }

      .nav-con-title-active {
        color: #3B5377;
        font-weight: 500;
        padding-bottom: 0.21rem;
        border-bottom: 0.01rem solid #3B5377;
      }
    }
  }

  .content {
    padding: 0 1.7rem;
    margin-top: 0.8rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .con {
      flex: 1;
      display: flex;
      justify-content: space-between;

      .item {
        width: (calc(100% - 2.26rem))/3;
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
          width: 3.44rem;
          height: 2.66rem;
        }

        .name {
          font-weight: 500;
          font-size: 0.24rem;
          color: #333333;
          margin-top: 0.33rem;
        }
      }
    }

    .productLeft {
      background: url('../../assets/image/wireless/product-left.png') center no-repeat;
      background-size: contain;
      width: 0.48rem;
      height: 0.48rem;
      cursor: pointer;
      margin-right: 0.8rem;
    }

    .productLeft:hover {
      background: url('../../assets/image/wireless/product-left-active.png') center no-repeat;
      background-size: contain;
    }

    .productRight {
      background: url('../../assets/image/wireless/product-right.png') center no-repeat;
      background-size: contain;
      width: 0.48rem;
      height: 0.48rem;
      cursor: pointer;

      margin-left: 0.8rem;
    }

    .productRight:hover {
      background: url('../../assets/image/wireless/product-right-active.png') center no-repeat;
      background-size: contain;
    }
  }
}

.wl-spec {
  .nav {
    display: flex;
    justify-content: center;

    .nav-con {
      width: 100%;
      padding-top: 0.22rem;
      background: #FFFFFF;
      box-shadow: 0 0.03rem 0.06rem 0.01rem rgba(0, 0, 0, 0.16);
      display: flex;
      align-items: center;

      .nav-con-title {
        margin-left: 0.8rem;
        font-weight: 400;
        font-size: 0.16rem;
        color: #333333;
        padding-bottom: 0.22rem;
      }

      .nav-con-title-active {
        color: #347DEA;
        padding-bottom: 0.21rem;
        border-bottom: 0.01rem solid #347DEA;
      }
    }
  }


}

.managingPatientSize {
  padding: 1rem 0 1.68rem 0;

  .data {
    padding: 0.8rem 4.5rem 0 3.8rem;
    display: flex;
    justify-content: space-between;

    .item {
      //width: 2.83rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;

      .line1 {
        display: flex;
        align-items: baseline;
        padding: 0 0.35rem 0.2rem 0.35rem;
        border-bottom: 0.01rem solid #999999;;

        img {
          width: 0.4rem;
        }

        .number {
          font-family: DIN Condensed, DIN Condensed;
          font-weight: bold;
          font-size: 0.54rem;
          color: #000000;
          margin-left: 0.2rem;
          margin-right: 0.1rem;
        }

        .text {
          font-size: 0.26rem;
          color: #333333;
          font-weight: 500;
        }

      }

      .line2 {
        font-weight: 400;
        font-size: 0.2rem;
        color: #333333;
        margin-top: 0.2rem;
      }
    }
  }

  .carousel {
    padding: 0 2.83rem 0 2.83rem;

    .carousel-track {
      margin-top: 0.8rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;

      .productLeft {
        background: url('../../assets/image/wireless/product-left.png') center no-repeat;
        background-size: contain;
        width: 0.48rem;
        height: 0.48rem;
        margin-right: 0.2rem;
        cursor: pointer;
        position: absolute;
        left: -0.8rem;
        top: 27%;
      }

      .productLeft:hover {
        background: url('../../assets/image/wireless/product-left-active.png') center no-repeat;
        background-size: contain;
      }

      .productRight {
        background: url('../../assets/image/wireless/product-right.png') center no-repeat;
        background-size: contain;
        width: 0.48rem;
        height: 0.48rem;
        margin-right: 0.2rem;
        cursor: pointer;
        position: absolute;
        right: -1rem;
        top: 27%;
      }

      .productRight:hover {
        background: url('../../assets/image/wireless/product-right-active.png') center no-repeat;
        background-size: contain;
      }

      .carousel-item {
        background: #FFFFFF;
        width: calc((100% - 0.8rem) / 3);

        img {
          width: 100%;
          height: 2.68rem;
        }

        .bot {
          padding: 0.2rem;

          .title {
            font-weight: 500;
            font-size: 0.18rem;
            color: #333333;
            margin-top: 0.2rem;
          }
          .tagsBox{
            color: black;
            display: flex;
            margin-top: 0.2rem;
            .tags{
              background-color: rgba(254, 241, 0, .5);
              padding: .05rem .2rem;
              font-weight: 400;
              margin-right: 0.1rem;
            }
            .tags:last-child{
              margin-right: 0;
            }
          }

          .desc {
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            font-weight: 400;
            font-size: 0.16rem;
            color: #666666;
            line-height: 0.3rem;
            margin-top: 0.2rem;
          }
        }

      }
    }
  }

  .hr2 {
    width: 8.82rem;
    //border-top: none;
    //border-right: none;
    //border-left: none;
    //box-shadow: 0 .02rem .02rem .02rem rgba(0, 0, 0, .16);

    margin-top: 0.76rem;
    border-bottom: 0.02rem solid rgba(0, 0, 0, 0.1); /* 下边框 */
    box-shadow: 0 0.01rem 0.03rem rgba(0, 0, 0, 0.16); /* 下边框阴影 */
    margin-bottom: -0.3rem;
  }

  .title {
    font-weight: 500;
    font-size: 0.32rem;
    color: #333333;
    text-align: center;
  }

  background: url('../../assets/image/wireless/mapBg.png') center no-repeat;
  background-size: cover;
  color: #fff;

  .el-row {
    height: 100%;

    .el-col {
      height: 100%;

      #china-map {
        height: 6.5rem
      }
    }
  }
}

.customer-title {
  font-weight: 500;
  font-size: 0.32rem;
  color: #333333;
  text-align: center;
  margin: 0.12rem 0 0.8rem 0;
}

.scroll-container {
  position: relative;
  width: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  overflow: hidden;
  mask-image: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 10%, rgb(0, 0, 0) 90%, rgba(0, 0, 0, 0) 100%);
  -webkit-mask-image: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 10%, rgb(0, 0, 0) 90%, rgba(0, 0, 0, 0) 100%);
}


.scroll-content-wrapper {
  display: flex;
  animation: scroll-right 60s linear infinite;
}

.scroll-content-wrapper-second {
  display: flex;
  animation: scroll-left 60s linear infinite;
}

.scroll-content-wrapper:hover, .scroll-content-wrapper-second:hover {
  animation-play-state: paused;
}


.scroll-content {
  img {
    width: 100%;
  }

  position: relative;
  flex: none;
  width: 2.3rem;
  height: 1.2rem;
  /* height: 200px; */
  /*  background-color: lightblue; */
  margin-right: 0.2rem; /* Space between elements */
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5em;
  overflow: hidden; /* Ensure content doesn't overflow */
  text-align: center; /* Center text horizontally */
  border: 0.01rem solid #f0f0f0;
}

.more-info {
  display: none; /* Initially hide the more-info div */
  position: absolute;
  top: 50%; /* Align to the center vertically */
  left: 50%; /* Align to the center horizontally */
  transform: translate(-50%, -50%);
  background-color: rgba(255, 255, 255, 0.8); /* Semi-transparent white background */
  padding: 0.1rem 0.2rem; /* Padding for the button */
  cursor: pointer; /* Change cursor to pointer on hover */
  z-index: 1; /* Ensure it's above the scroll-content */
  background-color: #00AA72;
  font-size: 0.14rem;
  color: #FFF;
}

.scroll-content:hover .more-info {
  display: block; /* Show more-info on hover */
}


.scroll-content:hover::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  //background-color: white;
  opacity: 0.8; /* Adjust opacity as needed */
}

@keyframes scroll-left {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

@keyframes scroll-right {
  0% {
    transform: translateX(-50%);
  }
  100% {
    transform: translateX(0%);
  }
}

.vh {
  visibility: hidden;
}

.point-active-school {
  background: #8900FE !important;
}

.point-active-school-text {
  color: #8900FE !important;
}

.point-active-teacher {
  background: #027FFE !important;
}

.point-active-teacher-text {
  color: #027FFE !important;
}

.point-active-parent {
  background: #2DE002 !important;
}

.point-active-parent-text {
  color: #2DE002 !important;
}

.point-active-student {
  background: #FF8902 !important;
}

.point-active-student-text {
  color: #FF8902 !important;
}
.code {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 99999;
  background-color: rgba(0, 0, 0, 0.8); // 使用 rgba 设置背景色和透明度
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;


  .con {
    background-color: white; // 设置子元素背景色为白色
    opacity: 1; // 设置子元素透明度为 1
    padding: 0.4rem 0.3rem;
    max-width: 3rem;
    border-radius: 0.3rem;
    text-align: center;
    .t3{
      font-size: 0.25rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/smartCampus/smartCampus.vue